var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C10.866 14.5 14 11.366 14 7.5C14 3.63401 10.866 0.5 7 0.5C3.13401 0.5 0 3.63401 0 7.5C0 11.366 3.13401 14.5 7 14.5Z",
    fill: "#004CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7.5V11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7.5",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00026 4.2312C6.92237 4.2312 6.84623 4.2543 6.78147 4.29757C6.7167 4.34085 6.66623 4.40235 6.63642 4.47431C6.60662 4.54627 6.59882 4.62545 6.61401 4.70185C6.62921 4.77824 6.66671 4.84841 6.72179 4.90349C6.77687 4.95856 6.84704 4.99607 6.92343 5.01126C6.99982 5.02646 7.07901 5.01866 7.15097 4.98885C7.22293 4.95905 7.28443 4.90857 7.32771 4.84381C7.37098 4.77905 7.39407 4.70291 7.39407 4.62502C7.39421 4.57326 7.38412 4.52199 7.36438 4.47415C7.34464 4.4263 7.31563 4.38284 7.27904 4.34624C7.24244 4.30964 7.19897 4.28064 7.15113 4.2609C7.10329 4.24116 7.05202 4.23106 7.00026 4.2312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconHover);
export default __webpack_public_path__ + "static/media/InfoIconHover.e23cfa0af8d2500b8ccd0888ddc80dda.svg";
export { ForwardRef as ReactComponent };